import { useMutation, useQueryClient } from '@tanstack/react-query';
import { voicesApi } from '../services/voicesApi';
import { toast } from 'sonner';

export const useDeleteVoice = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id) => voicesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voices'] });
      queryClient.invalidateQueries({ queryKey: ['voices-dropdown'] });
      toast.success('Voz excluída com sucesso!');
    },
    onError: (error) => {
      toast.error(`Erro ao excluir voz: ${error.message}`);
    },
  });
};
